import {
  STORYTELLING_COURSE_CODE,
  CREATOR_MASTER_COURSE_CODE,
  DEAR_ALYNE_COURSE_CODE,
  THE_UNSTOPPABLE_CONFIDENCE_COURSE_CODE,
  TABOO_TOPICS_COURSE_CODE,
  MONEY_COURSE_CODE,
  UNLOCKING_TIKTOK_WITH_MING_CODE,
  courseLinks,
  VFX_COURSE_CODE,
  FACEBOOK_ONDEMAND_COURSE_CODE,
  CRYPTO_CREATOR_MASTER_COURSE,
  CRYPTO_CREATOR_MASTER_COURSE_ONDEMAND_COURSE_CODE,
  ULTIMATE_VIRAL_VIDEO_COURSE_CODE,
} from '../../data/coursesData';

export const onDemandCourses = {
  id: 'ondemand-courses',
  name: 'ON DEMAND CLASSES',
  icon: 'bulb-on',
  description: '1 Day Courses to start your journey!',
  type: 'icon-name-description-card',
  subLinks: [
    {
      name: 'Art of Storytelling',
      link: courseLinks[STORYTELLING_COURSE_CODE],
      external: false,
    },
    {
      name: 'The Future of Crypto',
      link: courseLinks[CRYPTO_CREATOR_MASTER_COURSE_ONDEMAND_COURSE_CODE],
      external: false,
    },
    {
      name: 'Dear Alyne Content Creator Crash Course',
      link: courseLinks[DEAR_ALYNE_COURSE_CODE],
      external: false,
    },
    {
      name: 'How To Crush It On TikTok',
      link: courseLinks[UNLOCKING_TIKTOK_WITH_MING_CODE],
      external: false,
    },
    {
      name: 'Unstoppable Confidence with Project Nightfall',
      link: courseLinks[THE_UNSTOPPABLE_CONFIDENCE_COURSE_CODE],
      external: false,
    },
    {
      name: 'How To Crush It On Facebook',
      link: courseLinks[FACEBOOK_ONDEMAND_COURSE_CODE],
      external: false,
    },
  ],
};

export const liveCourses = {
  id: 'live-courses',
  name: 'LIVE CLASSES',
  icon: 'graduation-cap',
  description: 'In-depth and extensive learnings to be a pro creator.',
  type: 'icon-name-description-card',
  subLinks: [
    {
      name: 'Crypto Creator Mastercourse',
      link: courseLinks[CRYPTO_CREATOR_MASTER_COURSE],
      external: false,
    },
    {
      name: 'Creator Mastercourse',
      link: courseLinks[CREATOR_MASTER_COURSE_CODE],
      external: false,
    },
    {
      name: "Let's Talk Money: For Aspiring Digital Nomads and Creators",
      link: courseLinks[MONEY_COURSE_CODE],
      external: false,
    },
    {
      name: 'Advanced Editing Effects',
      link: courseLinks[VFX_COURSE_CODE],
      external: false,
    },
    {
      name: 'Sensitive Topics with Dear Alyne',
      link: courseLinks[TABOO_TOPICS_COURSE_CODE],
      external: false,
    },
    {
      name: 'Ultimate Viral Video Course by Smile Squad',
      link: courseLinks[ULTIMATE_VIRAL_VIDEO_COURSE_CODE],
      external: false,
    },
  ],
};

export const headerNavLink = [
  {
    name: 'Courses',
    external: false,
    type: 'text',
    isCourseNav: true,
    link: '#',
    isLink: false,
  },
  {
    name: 'Bundles',
    link: '/#bundle',
    type: 'text',
    external: false,
    isLink: true,
  },
  {
    name: 'Free Trial',
    external: false,
    type: 'text',
    link: '/trial',
    isLink: true,
  },
  {
    name: 'For Business',
    link: '/course/business',
    type: 'text',
    external: false,
    isLink: true,
  },
  // {
  //   name: 'Blog',
  //   link: 'https://blog.nas.academy/blog/',
  //   type: 'text',
  //   external: true,
  //   isLink: true,
  // },
  {
    name: 'Impact',
    link: '/impact',
    type: 'text',
    external: false,
    isLink: true,
  },
  {
    name: 'About',
    link: '/about-us',
    type: 'text',
    external: false,
    isLink: true,
  },
];

const trainerHeaderNavLink = [
  {
    name: 'Courses',
    link: '#',
    external: false,
    type: 'text',
    isLink: false,
    subLinks: [
      {
        name: 'Creator Mastercourse',
        link: '/course/creator',
        external: false,
      },
      {
        name: 'Art of Storytelling',
        link: '/course/storytelling',
        external: false,
      },
      {
        name: 'Dear Alyne Content Creation',
        link: 'https://dearalyne.nas.academy',
        external: true,
      },
      {
        name: 'Trial Class',
        link: '/trial',
        external: false,
      },
    ],
  },
  {
    name: 'Trainers',
    link: '/trainers',
    type: 'text',
    external: false,
    isLink: true,
  },
  {
    name: 'Corporate',
    link: '/course/business',
    type: 'text',
    external: false,
    isLink: true,
  },
  {
    name: 'Course Picker',
    link: '/best-for-me',
    type: 'text',
    external: false,
    isLink: true,
  },
  {
    name: 'Question?',
    link: '/faq',
    type: 'text',
    external: false,
    isLink: true,
  },
  {
    name: 'Be A Trainer',
    link: '/trainers/apply',
    type: 'button',
    external: false,
    isLink: true,
  },
];

export const getHeaderNavLinksForPage = (pageName) => {
  const baseNavlinks = headerNavLink;

  // Show MX Player only for India
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const showMxPlayerOnNav = timezone === 'Asia/Calcutta';

  switch (pageName) {
    case 'trainer':
      return trainerHeaderNavLink;

    default: {
      if (showMxPlayerOnNav) {
        return baseNavlinks.concat({
          name: 'MX Takatak',
          link: '/mxtakatak',
          type: 'text',
          external: false,
          isLink: true,
        });
      }
      return headerNavLink;
    }
  }
};
